export default "__VITE_ASSET__VidQU7H8__"